import { Box, FormHelperText, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { CheckoutContext } from "contexts/Checkout";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { AddOnItemName } from "schemas/dashboard";
import { DisplayName } from "schemas/payments";

import SeeExample from "./SeeExample";

interface Props {
  displayName: string;
  description?: string;
  isSwitching: boolean;
}

const PlanDetails = ({ displayName, description, isSwitching }: Props) => {
  const { subscription } = useContext(SubscriptionContext);
  const { plan } = useContext(CheckoutContext);

  return (
    <>
      {isSwitching && subscription?.subscription?.planName && (
        <FormHelperText sx={{ color: grey[500] }}>
          Switching from {DisplayName[subscription?.subscription?.planName]}{" "}
          plan
        </FormHelperText>
      )}
      <Typography
        variant="h2"
        component="div"
        sx={{
          color: "black",
          fontSize: 40,
          fontWeight: 500,
          mb: 1,
        }}
      >
        {displayName}

        {plan === AddOnItemName.partnership_data && <SeeExample theme="dark" />}
      </Typography>

      {plan === AddOnItemName.partnership_data ? (
        <Box>
          Access insider data on brand partnerships - see if they pay, gifted
          products, when they last collaborated, where they operate, and if
          their contact is verified or responsive.
        </Box>
      ) : (
        <Typography component="div">{description}</Typography>
      )}
    </>
  );
};

export default PlanDetails;
